
import { defineComponent, ref, reactive, onMounted, toRefs, computed } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import Form from './Form.vue'
import ExportModal from '../../../../components/personnel/User/ExportModal.vue'
import { Modal } from "ant-design-vue"

export default defineComponent({
    components: {
        Form,
        ExportModal,
    },
    setup(){
        const name = ref('Users');
        const store = useStore()
        const router = useRouter()

        const visible = ref(false)
        const visible2 = ref(false)
        const form_loading = ref(false)

        const form = reactive({
            id: 0,
            role_id: '',
            is_active: false,
        })

        

        const form2 = reactive({
            status: '',
            roles: '',
        })

        const fields = ref<any>([
            {
                title: 'Group',
                dataIndex: 'business_unit.name',
            },
            {
                title: 'Email',
                dataIndex: 'email',
            },
            {
                title: 'First Name',
                dataIndex: 'first_name',
            },
            {
                title: 'Middle Name',
                dataIndex: 'middle_name',
            },
            {
                title: 'Last Name',
                dataIndex: 'last_name',
            },
            {
                title: 'Role',
                dataIndex: 'role.name',
            },
            {
                title: 'Action',
                dataIndex: 'action',
                slots: {customRender: 'action'},
                align: 'center'
            }
        ])

        const active = ref([])
        const inactive = ref([])
        
        const loadActive = (payload = {page: 1, is_active: true}) => {
            payload['is_active'] = true;
            store.dispatch('BusinessUnitUser/index', payload).then((res:any) => {
                active.value = res.data
            })
        }

        const loadInactive = (payload = {page: 1, is_active: false}) => {
            payload['is_active'] = false;
            store.dispatch('BusinessUnitUser/index', payload).then((res:any) => {
                inactive.value = res.data
            })
        }

        const activate =  (record:any) => {
            store.dispatch('BusinessUnitUserEmail/activate', record.id)
            .then(() => {
                reload();
            })
        }

        const editRecord = (record:any) => {
            // visible.value = true;
            const { id, role_id, is_active } = toRefs(form)
            id.value = record.id;
            role_id.value = record.role_id;
            is_active.value = record.is_active;
            
            visible.value = true;
        }

        const handleSaving = (payload:any) => {
            form_loading.value = true
            store
                .dispatch('BusinessUnitUserEmail/activate', payload)
                .then(() => {
                    visible.value = false
                    form_loading.value = false
                    reload();
                })
        }

        const filterRecordActive = (payload: any) => {
            loadActive(payload)
        }
        
        const filterRecordInactive = (payload: any) => {
            loadInactive(payload)
        }

        const reload = (() => {
            loadActive()
            loadInactive()
            setTimeout(function(){
                window.location.reload();
            }, 2000);
        })

        const handleSaving2 = () => {
            const xhr = new XMLHttpRequest();

            let api_url = process.env.VUE_APP_REPORT_URL;


            let download_url = api_url + "user_reports/?";

            if(form2.roles != "") {
                download_url += "roles=" + form2.roles;
            }

            if(form2.status != "") {
                if(form2.roles != "") {
                    download_url += "&";
                } 
                download_url += "status=" + form2.status;
            }
            console.log(download_url);

            xhr.onreadystatechange = function () {
                if (xhr.readyState == 4 && xhr.status == 200) {
                window.location.href = download_url;
                return;
                }

                if (xhr.readyState === 4 && xhr.status === 422) {
                Modal.error({
                    title: "Download failed",
                    content: "Nothing to export.",
                });
                return;
                }

                if (xhr.readyState === 4 && xhr.status === 500) {
                Modal.error({
                    title: "Download failed",
                    content:
                    "There was an error while downloading the file. Please try again later.",
                });
                return;
                }

                if (xhr.readyState === 4 && xhr.status === 401) {
                Modal.error({
                    title: "Permission Denied\n",
                    content: "You don't have permission to perform such operation..",
                });
                return;
                }
        }

        xhr.open("head", download_url);
        xhr.setRequestHeader("Authorization", `Bearer ${window.localStorage.getItem('PAYMENT_PORTAL_TOKEN')}`);
        xhr.send(null);
    }

    onMounted(() => {
        loadActive()
        loadInactive()
    })

    const loading = computed(() => store.getters['BusinessUnitUser/status'])

    return {
        name,
        fields,
        loading,
        form_loading,
        active,
        inactive,
        visible,
        visible2,
        form,
        form2,
        handleSaving,
        handleSaving2,
        editRecord,
        activate,
        filterRecordActive,
        filterRecordInactive,
    }
    }
});

